import { getCookie, setCookie } from '../utils';
import { gsap } from 'gsap';
export class Popup {
    el;
    formID;
    token;
    constructor(el) {
        this.el = el;
        this.formID = $(this.el).data('form') || 0;
        this.token = $(this.el).data('token') || 'yes';
        this.init();
    }
    init() {
        const seen = getCookie('scrimPopupSeen');
        const submitted = getCookie('scrimPopupSubmitted');
        if (seen === this.token || submitted === this.token)
            return;
        $(this.el)
            .on('click', '[href="#popup-close"]', (e) => {
            e.preventDefault();
            this.close();
        });
        $(document)
            .on('gform_confirmation_loaded', (e, form_id) => {
            if (form_id === this.formID) {
                setCookie('scrimPopupSubmitted', this.token);
            }
        });
        setTimeout(() => { this.open(); }, 5000);
    }
    open() {
        $('html').addClass('popup-open');
        $(this.el).addClass('open');
        const tl = gsap.timeline();
        tl.to($(this.el), { duration: 0.3, pointerEvents: 'auto', opacity: 1 }, 0);
        tl.fromTo($('.popup-image', this.el), { opacity: 0, x: -24 }, { duration: 0.5, opacity: 1, x: 0 }, 0.25);
        tl.fromTo($('.popup-content', this.el), { opacity: 0, x: +24 }, { duration: 0.5, opacity: 1, x: 0 }, 0.3);
    }
    close() {
        $('html').removeClass('popup-open');
        $(this.el).removeClass('open');
        const tl = gsap.timeline();
        tl.fromTo($('.popup-content', this.el), { opacity: 1, x: 0 }, { duration: 0.25, opacity: 0, x: +24 }, 0);
        tl.fromTo($('.popup-image', this.el), { opacity: 1, x: 0 }, { duration: 0.25, opacity: 0, x: -24 }, 0);
        tl.to($(this.el), { duration: 0.3, pointerEvents: 'none', opacity: 0 }, 0.15);
        setCookie('scrimPopupSeen', this.token, 7);
    }
}
